import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=46509c5c&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46509c5c')) {
      api.createRecord('46509c5c', component.options)
    } else {
      api.reload('46509c5c', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=46509c5c&", function () {
      api.rerender('46509c5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Tfvs1fRTZdVR/JS/comp/IncreaseNumber.vue"
export default component.exports